
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modal/[...url]",
      function () {
        return require("private-next-pages/modal/[...url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modal/[...url]"])
      });
    }
  